import {l} from 'types/typescriptdefinisjoner_lederplan';
import {RessursFeilhåndtering} from '../RessursFeilhåndtering';
import _ from "lodash";
import {gettextCatalog} from 'angular-gettext';
import {regNavn} from '../tredjepartsTjenestenavn';
import {Debugger} from "debug";

const debug:Debugger = require('debug')('FellesAutentiseringsRessurs');

export class FellesAutentiseringsRessurs {
    static regNavn = 'FellesAutentiseringsRessurs';

    static forInjisering() {
        return [
            regNavn.ng.$resource,
            RessursFeilhåndtering.regNavn,
            regNavn.gettext.gettextCatalog,
            FellesAutentiseringsRessurs
        ]
    }

    private ressurs: ng.resource.IResourceClass<l.AutentisertOkModell>;

    constructor(private $resource: ng.resource.IResourceService,
                private ressursFeilhåndtering: RessursFeilhåndtering,
                private gettextCatalog: gettextCatalog) {
        this.ressurs = $resource<l.AutentisertOkModell>('/api/fellesautentisering', {}, {
            ønskerNyttPassord: {method: "POST", url: "/api/fellesautentisering/onskerNyttPassord"},
            resettokenKreverEid: {method: "GET", url: "/api/fellesautentisering/resettokenKreverEid/:token"}
        });
    }

    ønskerNyttPassord(brukernavn: string): l.PassordResetResponsModell {
        return this.ressurs["ønskerNyttPassord"](
            {brukernavnEllerEpost: brukernavn},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Feil under resetting av passord")));
    }

    resettokenKreverEid(token: string): l.KreverEidModell {
        return this.ressurs['resettokenKreverEid'](
            {token: token},
            _.noop,
            this.håndterFeil(()=>this.gettextCatalog.getString("Kunne ikke sjekke eId-krav")));
    }

    private håndterFeil(melding: () => string){
        return this.ressursFeilhåndtering.håndterRequestFeil(melding);
    }
}
